module.exports = __webpack_public_path__ + "img/bcw.181ad6f4.png";